// duplicated in src/styles/_constants.scss
export const HEADER_HEIGHT = 75
export const HEADER_HEIGHT_MOBILE = 75 + 44

export const NOTIFICATION_TOP = 69
